
import {SET_REVIEW_EMAILS} from '../actions/_CONSTANTS';

const reviewEmails = (state=[], action) => {
  switch(action.type){
    case SET_REVIEW_EMAILS:
      return action.payload;
    default:
      return state;
  }
}

export default reviewEmails;

